/* import __COLOCATED_TEMPLATE__ from './cognex-camera.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();